import React from 'react';

export const SectionWrapper = ({ children, marginBottom = 32 }) => {
  return (
    <section style={{ marginBottom }}>{children}</section>
  );
};
